module.exports = __webpack_public_path__ + "media/images/amazon_logo-18373a43fc59a72d892abba5c6d8e0b2.png";